const riot = require('riot');

riot.tag2('modal-note-move', '<div class="f fclm bg-white w472 h547 bg-white border border-pale rounded-8 px16 pt19 pb24 s-s-full" ref="modal"> <div class="flex-fixed f fm fbw mb18"> <div class="f fm"> <div class="bold fs16 lh13 mr8">ノートを移動</div><i class="icon-help cursor-pointer fs16 text-label_dark_primary tooltip" aria-label="{app.data.tips.note_move}" data-tooltip-offset-top="4"></i> </div><i class="icon-close fs24 text-label_dark_medium cursor-pointer" onclick="{close}"></i> </div> <div class="bold lh13 mb6">プロジェクト一覧</div> <div class="input small pale f fm pr8 mb8"><i class="icon-search text-label_dark_disabled fs16 mr8"></i> <input class="w-full" ref="search" placeholder="プロジェクトを検索する" oninput="{debounceSearch}"><i class="icon-close fs16 cursor-pointer ml8" onclick="{onDeleteQuery}" if="{refs.search.value}"></i> </div> <div class="s-full border border-separator_opacity rounded-8 overflow-scroll mb24"> <div class="pt12 pb4 border-bottom-not-last" each="{items, key in displayProjects}" if="{items.length}"> <div class="pr8 pl12 fs12 text-label_dark_medium lh13">{key}</div> <label class="f fm py10 px8 cursor-pointer hover-trigger hover-bg-pale" ref="project" each="{item in items}"> <input class="mr8" type="radio" name="project" onchange="{onChangeToProject}" checked="{item.data.project_id === currentProjectId}"> <div class="flex-fixed s20 rounded-4 overflow-hidden border mr4"> <div class="s-full" if="{!item.data.project_icon_image}" riot-style="background-color: hsl({app.utils.stringToColorAngle(item.data.project_name)}, 50%, 70%);"></div><img class="block s-full object-fit-cover" if="{item.data.project_icon_image}" riot-src="{app.utils.getImageUrl(item.data.project_icon_image)}"> </div> <div class="line-clamp-1 word-break-all lh15 text-label_dark_primary">{app.utils.getProjectName(item.data.project_name)}</div> </label> </div> </div> <button class="button w220 h40 primary mxa" onclick="{onMoveProject}">移動する</button> </div>', 'modal-note-move input::placeholder,[data-is="modal-note-move"] input::placeholder{color:rgba(29,40,76,0.2);font-size:13px} modal-note-move input:focus,[data-is="modal-note-move"] input:focus{outline:none !important}', 'class="f fh bg-overlay_secondary" spat-animation="push"', function(opts) {
    this.on('mount', () => {

      this.currentProjectId = this.opts.notes[0].getProject().id;

      this.displayProjects = this.getProjectsBySection(app.store.projectsUsersStore.items);
      requestAnimationFrame(() => {
        this.refs.search.focus();
      });
      this.update();
    });

    this.onChangeToProject = (e) => {
      this.toProjectId = e.item.item.data.project_id;
    };

    this.onMoveProject = async (e) => {
      if (!this.toProjectId) {
        spat.modal.alert('移動先のプロジェクトを設定してください');
        return;
      }

      let from_project = this.opts.notes[0].getProject();

      let transferred_notes = await app.api.child(from_project.path).child('notes').child('transfer').put({
        note_ids: this.opts.notes.map(note => note.id),
        to_project_id: this.toProjectId,
      });

      this.trigger('move', {
        notes: transferred_notes.items,
        from: from_project.id,
        to: this.toProjectId,
      });

      this.close();
      app.utils.openToast('update');
    };

    this.getProjectsBySection = (items) => {
      const DM_GROUP_NAME = 'Direct Message';
      let sections = _.groupBy(items, (project) => {
        if (project.data.project_kind === 'direct') {
          return DM_GROUP_NAME;
        }
        let names = project.data.project_name.split('/');
        return names.length >= 2 ? names[0] : 'Projects';
      });

      let temp = sections[DM_GROUP_NAME];
      delete sections[DM_GROUP_NAME];
      sections[DM_GROUP_NAME] = temp;
      return sections;
    };

    this.debounceSearch = _.debounce(() => {
      let value = this.refs.search.value.trim();
      let args = {
        value: value,
        items: app.store.projectsUsersStore.items,
        key_or_callback: 'data.project_name'
      };
      let hits = app.utils.fuzzySearchItems(args);
      if (hits.length) {
        this.displayProjects = this.getProjectsBySection(hits);
      } else {
        this.displayProjects = [];
      }
      this.update();
    }, 256);

    this.onDeleteQuery = async () => {
      this.refs.search.value = '';
      this.refs.search.focus();
      this.displayProjects = this.getProjectsBySection(app.store.projectsUsersStore.items);
      this.update();
    };
});